export default __webpack_public_path__ + "static/media/Community-living-insurance-policy-2025.e37d333b.pdf";